<template>
	<div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<col width="5%">
					<col width="70%">
                    <col width="15%">
					<col width="5%">
					<!--col width="10%"-->
					<col width="5%">
					<thead>
						<tr>
							<th>#
								<a class="left" href="#" @click="toggleOrder($event, 'id')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyId }" >sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'projeto.titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }" >sort</i>
								</a>
							</th>
                            <th>
                                Status
                            </th>
							<th>
								Nota
							</th>
							<!--th>
								% Aval
							</th-->
							<th>
								Habilitado?
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(avaliacao, index) in filteredAvaliacoes" :key="index">
							<td>{{index + 1}}</td>
							<td>
								<a :href="'/avaliacoes-aval/' + avaliacao.id">
									{{avaliacao.inscricao.acao.titulo}}
								</a>
							</td>
                            <td>
                                <p><span :class="retornaCssBadgeDeAcordoComStatusConclusao(avaliacao.status_de_conclusao)"
                                         data-badge-caption="">
                                    {{ avaliacao.status_de_conclusao }}</span>
                                </p>
                            </td>
							<td>
								<span>
									{{avaliacao.pontuacao_total}}
								</span>
							</td>
							<!--td>
								<span>
									{{avaliacao.percAval}}
								</span>
							</td-->
							<td>
								<label v-if='avaliacao.impedido' class="waves-light btn red left darken-1"><i class="material-icons">clear</i></label>
								<label v-else class="waves-light btn left cyan"><i class="material-icons">check</i></label>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

</template>

<script>
    export default {
		name: "VueAvaliacoesAvalList",
		props: [
			'avaliacoes',
		],
		data () {
			return {
				listaAvaliacoes: JSON.parse(this.avaliacoes),
				sortDirection: 'asc',
				filterTerm: '',
				sortProperty: 'id',
				sortPropertyId: true,
				sortPropertyProjeto: false,
				justificativa: false,
				texto: '',
				notaTotal:0,
				avaliado:false


			}
		},
		computed: {


			filteredAvaliacoes: function () {
				var self = this
				return _.orderBy(self.listaAvaliacoes.filter(function (avaliacao) {
					var searchRegex = new RegExp(self.filterTerm, 'i')
					return (
						searchRegex.test(avaliacao.inscricao.acao.titulo)
					)
				}), this.sortProperty, this.sortDirection)
			},
		},
		methods: {
            retornaCssBadgeDeAcordoComStatusConclusao(status_conclusao)
            {
                const spanBadge = 'new badge '

                if(status_conclusao === 'Distribuído')
                    return spanBadge + 'blue lighten-2';
                if(status_conclusao === 'Em Andamento')
                    return spanBadge + 'amber darken-3';
                if(status_conclusao === 'Finalizado')
                    return spanBadge + 'green';
            },

			toggleOrder(ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field) {
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'id':
					  this.sortPropertyId = value
					  break;
					case 'titulo':
					  this.sortPropertyProjeto = value
					  break;
					default:
				}
			},
			colocarContador() {
				$("#justificativa").characterCounter();
			}
		},
	}
</script>